import { useCallback, useEffect, useState } from 'react';
import { GroupInterface, UserProgramInfo } from '../utils/programTypes';

export const useAdminProgramSelection = () => {
  const [selectedProgram, setSelectedProgram] = useState<GroupInterface | undefined>();
  const [openSidebar, setOpenSidebar] = useState(false);

  useEffect(() => {
    if (selectedProgram) setOpenSidebar(true);
  }, [selectedProgram]);

  const openProgram = useCallback((program: GroupInterface) => {
    setSelectedProgram(program);
  }, []);

  const closeProgram = useCallback(() => {
    setSelectedProgram(undefined);
    setOpenSidebar(false);
  }, []);

  return { selectedProgram, openSidebar, openProgram, closeProgram };
};

export const useUserProgramSelection = () => {
  const [selectedProgram, setSelectedProgram] = useState<UserProgramInfo | undefined>();
  const [openDrawer, setOpenDrawer] = useState(false);

  const openProgram = useCallback((program: UserProgramInfo) => {
    setSelectedProgram(program);
    setOpenDrawer(true);
  }, []);

  const closeProgram = useCallback(() => {
    setSelectedProgram(undefined);
    setOpenDrawer(false);
  }, []);

  return { selectedProgram, openDrawer, openProgram, closeProgram };
};
